import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

export const NotDigitalWrapper = () => {
	return <></>;
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {};

const NotDigital = connect(mapStateToProps, mapDispatchToProps)(NotDigitalWrapper);

NotDigitalWrapper.propTypes = {};

export { NotDigital };
